import { PARAM_DATE_FROM as _, PARAM_DATE_TO as o, PARAM_ADULTS as t, PARAM_LOCATION as M } from "./index169.mjs";
const T = (e, r) => {
  const A = [_, o, t];
  return r && A.push(M), A.every((s) => !!e[s]);
};
export {
  T as isValidQueryValues
};
